export default __webpack_public_path__ + "db8c209fba5b7d41f7f5729e51cd5301.svg";